<div class="form-group">
    <label for="widgetSelect-{{ field.ID }}"> {{ 'formDetailWidget.widgetTypeLabel' | t }} </label>
    <ng-select
        id="widgetSelect-{{ field.ID }}"
        name="widgetSelect-{{ field.ID }}"
        [multiple]="false"
        [items]="widgetTypeModels"
        [(ngModel)]="widgetSettings.widgetType"
        (change)="changeType($event)"
        bindLabel="text"
        bindValue="type"
        [clearable]="false"
    >
        <ng-template ng-option-tmp ng-label-tmp let-item="item">
            <i class="fas {{ item.icon }} me-1" style="width: 20px; text-align: center"></i
            >{{ item.text }}
        </ng-template>
    </ng-select>
</div>

@if (field.SourceData) {
    <div>
        @if (widgetSettings.widgetType === widgetTypes.RiskMatrix) {
            <div class="form-group">
                <label for="widgetSelect-{{ field.ID }}">
                    {{ 'formDetailWidget.showRiskMatrixLabel' | t }}
                    <i
                        class="fas fa-info-circle ms-2"
                        matTooltip="{{ 'formDetailWidget.showRiskMatrixTooltip' | t }}"
                    ></i>
                </label>
                <cerrix-select-tree
                    [tree]="field.SourceData"
                    [(value)]="widgetSettings.widgetParam"
                    (onChangeSingleId)="saveModel()"
                    [multiselect]="false"
                >
                </cerrix-select-tree>
            </div>
        }
    </div>
}
